import tutorials from './tutorials';
import cometChat from './cometChat';
import radarFriends from './radarFriends';
import radarInvitations from './radarInvitations';
import radarUserProfile from './radarUserProfile';
import radarConfig from './radarConfig';
import radarRecommendations from './radarRecommendations';
import searchHistory from './searchHistory';
import campaigns from './campaigns';
import offerwallRewards from './offerwallRewards';
import radarConnections from './radarConnections';
import collectionsList from './cardCollections/collectionsList';
import ownedCollections from './cardCollections/ownedCollections';
import collectionProgress from './cardCollections/collectionProgress';
import collectionRanking from './cardCollections/collectionRanking';
import heroDiscoveries from './discoveries/discoveries';
import cards from './cards';
import surveys from './surveys';
import deals from './deals';
import slots from './slots';
import jobSlides from './jobSlides';

export default {
  ...tutorials,
  ...cometChat,
  ...radarFriends,
  ...radarInvitations,
  ...radarUserProfile,
  ...radarConfig,
  ...radarRecommendations,
  searchHistory,
  ...campaigns,
  ...offerwallRewards,
  ...radarConnections,
  ...collectionsList,
  ...ownedCollections,
  ...collectionProgress,
  ...collectionRanking,
  ...heroDiscoveries,
  ...cards,
  ...surveys,
  ...deals,
  ...slots,
  ...jobSlides,
};
